import { render } from "./NurserySchoolDiaryContainer.vue?vue&type=template&id=5e5a4ccf&ts=true"
import script from "./NurserySchoolDiaryContainer.vue?vue&type=script&lang=ts"
export * from "./NurserySchoolDiaryContainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__